import { t as e } from "../../utils-C1uyTI6x.js";
import { t } from "../../constants-B7fXbm2f.js";
import { t as n } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as r, createElementVNode as i, createStaticVNode as a, normalizeClass as o, openBlock as s } from "vue";
//#region ../src/icons/dialpad-star-mark-color.vue
var c = {
	name: "DtIconDialpadStarMarkColor",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (e) => Object.keys(t).includes(e)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return t[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded"), this.uniqueID = e();
	}
}, l = [
	"aria-label",
	"data-qa",
	"aria-hidden"
], u = ["fill"], d = ["id"];
function f(e, t, n, c, f, p) {
	return s(), r("svg", {
		"aria-label": n.ariaLabel,
		class: o([p.iconSizeClass, "d-icon d-icon--dialpad-star-mark-color"]),
		"data-qa": p.dataQA,
		"aria-hidden": p.ariaHidden,
		role: "img",
		"data-name": "Dialpad Star Mark Color",
		viewBox: "0 0 24 24",
		xmlns: "http://www.w3.org/2000/svg"
	}, [i("path", {
		d: "M18.882 11.327c.182-.085.143-.411-.051-.456-2.909-.668-5.173-3.332-5.66-6.674-.031-.222-.41-.274-.487-.066-1.253 3.993-3.964 7.118-7.57 8.642-.176.086-.14.39.048.437 2.84.705 5.046 3.322 5.54 6.599.033.216.38.265.458.062 1.444-4.178 4.21-7.316 7.722-8.544Z",
		fill: `url(#${e.uniqueID}a)`
	}, null, 8, u), i("defs", null, [i("linearGradient", {
		id: `${e.uniqueID}a`,
		x1: "5",
		y1: "4",
		x2: "20.858",
		y2: "17.876",
		gradientUnits: "userSpaceOnUse"
	}, [...t[0] || (t[0] = [a("<stop stop-color=\"#471571\"></stop><stop offset=\".031\" stop-color=\"#551B84\"></stop><stop offset=\".145\" stop-color=\"#7C229E\"></stop><stop offset=\".237\" stop-color=\"#9024A4\"></stop><stop offset=\".355\" stop-color=\"#B02290\"></stop><stop offset=\".483\" stop-color=\"#D32B86\"></stop><stop offset=\".603\" stop-color=\"#E92F6F\"></stop><stop offset=\".701\" stop-color=\"#F6484F\"></stop><stop offset=\".9\" stop-color=\"#FB7328\"></stop><stop offset=\".973\" stop-color=\"#F3960F\"></stop><stop offset=\"1\" stop-color=\"#F3960F\"></stop>", 11)])], 8, d)])], 10, l);
}
var p = /* @__PURE__ */ n(c, [["render", f]]);
//#endregion
export { p as default };

//# sourceMappingURL=dialpad-star-mark-color.js.map